/** @format */

import {styled} from '@mui/material/styles';
import {Box} from '@mui/material';

export const ChartContainer = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  padding: theme.spacing(4),
  backgroundColor: theme.palette.semantic_dark?.surface?.surface1,
  color: theme.palette.semantic_dark?.surface?.onSurface,
}));

export const ChartTitle = styled(Box)(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  fontSize: '28px',
  lineHeight: '28px',
  fontWeight: 400,
  gap: theme.spacing(2),
}));

export const MetricsContainer = styled(Box)(() => ({
  display: 'inline-flex',
  gap: '1px',
}));

interface MetricCardProps {
  isFirst?: boolean;
  isLast?: boolean;
}

export const MetricCard = styled(Box, {
  shouldForwardProp: prop => prop !== 'isFirst' && prop !== 'isLast',
})<MetricCardProps>(({isFirst, isLast, theme}) => ({
  padding: '12px',
  gap: theme.spacing(1),
  backgroundColor: theme.palette.semantic_dark?.surface?.surface2,
  minWidth: '120px',

  ...(isFirst && {
    borderTopLeftRadius: '8px',
    borderBottomLeftRadius: '8px',
  }),

  ...(isLast && {
    backgroundColor: theme.palette.semantic_dark?.good?.container,
    borderTopRightRadius: '8px',
    borderBottomRightRadius: '8px',
  }),
}));

export const MetricTitle = styled(Box)(() => ({
  fontSize: '14px',
  lineHeight: '16px',
  marginBottom: '4px',
  fontWeight: 500,
}));

export const MetricValue = styled(Box)(() => ({
  fontSize: '24px',
  lineHeight: '28px',
  fontWeight: 400,
}));

export const ChartSubtitle = styled(Box)(() => ({
  fontSize: '16px',
  lineHeight: '20px',
  fontWeight: 500,
}));